<mat-card appearance="outlined" class="task-detail-page">
    <mat-card-title class="task-detail-title">
        <div class="page-header">
            <div class="error-title">
                <h1>Something went wrong. Please try again later.</h1>
            </div>
        </div>
    </mat-card-title>
</mat-card>
